<template>
  <div class="AppBarDocumentSearchResultsLoader">
    <v-skeleton-loader
      v-for="n in 5"
      :key="n"
      type="avatar, heading"
    />
  </div>
</template>

<style lang="scss">
@import "@/scss/border-tokens";

.AppBarDocumentSearchResultsLoader {
  $skeleton-size: 20px;
  width: 80%;

  .v-skeleton-loader__avatar {
    max-height: $skeleton-size;
    min-height: $skeleton-size;
    max-width: $skeleton-size;
    min-width: $skeleton-size;
  }

  .v-skeleton-loader__bone {
    height: $skeleton-size;
    border-radius: get-radius('border-radius-2') !important;
    background: linear-gradient(90deg, #F1F2F3 46.5%, #FAFAFA 100%);
  }
}
</style>
